export const sweep = {};
	sweep.ID_LIST = 'list';
	sweep.ID_APPLICATION = 'app';
	sweep.ID_TWITTER = 'twitter';
	sweep.ID_FACEBOOK = 'facebook';
	sweep.ID_ADSFACEBOOK = 'adsfacebook';
	sweep.ID_INSTAGRAM = 'instagram';
	//sweep.ID_ADSINSTAGRAM = 'adsinstagram';
	sweep.ID_YOUTUBE = 'youtube';
	sweep.ID_MULTI = 'multi';
	sweep.ID_PHONE = 'phone';
	sweep.ID_IP = 'ip';

	sweep.ID_FACEBOOK_TPL = '5';
	sweep.ID_INSTAGRAM_TPL = '7';

	sweep.TYPE_LIKE = 0;
	sweep.TYPE_COMMENT = 1;
	sweep.TYPE_RETWEET = 4;
	sweep.TYPE_FOLLOWER = 5;
	sweep.TYPE_HASHTAG = 6;
	sweep.TYPE_UPLOAD = 7;
	sweep.TYPE_LEAD_ADS = 8;
	sweep.TYPE_LIVE = 9;
	sweep.TYPE_STORY_REPLYTO = 10;
	sweep.TYPE_STORY_MENTION = 11;
	sweep.TYPE_PRIZE = 69;

	sweep.MAX_POSTS_SELECTEDS = 10;
	sweep.MAX_POSTS_SELECTEDS_MULTI = 25;

	sweep.plan_starter = 'starter';
	sweep.plan_basic = 'basic';
	sweep.plan_pro = 'basicpro';
	sweep.plan_premium = 'premium';
	sweep.plan_wl = 'wl';

	sweep.subscription_link_basic = 'plans/add/'+sweep.plan_basic;//Purchase basic subscription
	sweep.subscription_link_pro = 'plans/add/'+sweep.plan_pro;//Purchase Pro Basic

	sweep.LIMIT_TWITTER_RT = 100;
	sweep.LIMIT_TWITTER_RT_MAX = 2000;
	sweep.LIMIT_TWITTER_PREMIUM_MAX = 60000;
	sweep.LIMIT_TWITTER_FOLLOWERS = 100000;
	sweep.LIMIT_YOUTUBE_COMMENTS = 1000;
	sweep.LIMIT_SUBSCRIPTION_PRO = 5000;
	sweep.LIMIT_INFINITE = 5000000000000;

	sweep.LIMIT_ADDITIONAL_ENTRIES = 20000;
	sweep.LIMIT_MAX_INSERT_LIST = (window.limit_list_max != undefined) ? window.limit_list_max : 1000000;
	sweep.LIMIT_LIST_PLANS = (window.limit_list_plans != undefined) ? window.limit_list_plans : [];
	sweep.MAX_UPDATE_PARTICIPANTS = 20000;
	sweep.LIMIT_EXPORT = 100000;
	sweep.HASHTAG_EXCLUSION_LIMIT = 10000;
	sweep.max_days_basic = 7;

	sweep.OPENED = 0;
	sweep.CLOSED = 1;

	sweep.PAYMENT_TESTMODE = 'test_mode';

	sweep.MAX_WINNERS_TO_ENABLE_LIVE = 8;

	sweep.permissions_manage_pages = ['pages_manage_ads','pages_manage_metadata','pages_read_engagement','pages_read_user_content'];//For replace with FB Version v7.0 with "manage_pages" permissions.
	sweep.permissions_publish_pages = ['pages_manage_posts','pages_manage_engagement'];//For replace with FB Version v7.0 with "publish_pages" permissions.
	sweep.permissions_instagram = ['instagram_basic','instagram_manage_comments'];

	//'pages_show_list', => LIST PAGES
	//'pages_read_engagement', => LIST POSTS
	//'pages_read_user_content' => LIST COMMENTS
	sweep.perms_basic_for_sweeps = ['pages_show_list','pages_read_engagement','pages_read_user_content'];
	sweep.perms_for_publish = ['pages_manage_posts'];
	sweep.perms_for_facebook_comment = ['pages_manage_engagement'];
	sweep.perms_for_instagram_comment = ['instagram_manage_comments'];
	sweep.perms_for_webhook = ['pages_manages_metadata'];


	//links to payment
	sweep.link_pricing_twitter = window.web_base_url + (window.is_spanish ? 'sorteo-en-twitter/#pricetypes' : 'twitter-sweepstakes/#pricetypes');
	sweep.link_pricing_facebook = window.web_base_url + (window.is_spanish ? 'sorteo-en-facebook/#pricetypes' : 'facebook-sweepstakes/#pricetypes');
	sweep.link_pricing_instagram = window.web_base_url + (window.is_spanish ? 'sorteo-en-instagram/#pricetypes' : 'instagram-sweepstakes/#pricetypes');
	sweep.link_pricing_youtube = window.web_base_url + (window.is_spanish ? 'sorteo-en-youtube/#pricetypes' : 'youtube-sweepstakes/#pricetypes');
	sweep.link_pricing_list = window.web_base_url + (window.is_spanish ? 'plataforma-multisorteo/' : 'sweepstakes-platform/');

	sweep.link_broadcast_demo = window.sweeps_url + 'show/' + ((window.is_spanish) ? '507847/SyZWkf5j4gmX' : '507869/ww7M0XM7c23x');